<template>
  <section class="grid-section">
    <div class="container">
      <div class="community-grid">
        <div
          v-for="(area, index) in projects"
          :key="area.name"
          class="community-card animate-up"
          :style="{ animationDelay: `${index * 0.1 + 0.3}s` }"
        >
          <div class="card-image">
            <img :src="area.image" :alt="area.name" />
            <div class="card-overlay">
              <button class="view-btn">VIEW LISTINGS</button>
            </div>
          </div>
          <div class="card-info">
            <h3>{{ area.name }}</h3>
            <p>{{ area.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import absoluteResidencyImg from '@/assets/images/AbsoluteResidency.png';
import bjbfBuildersImg from '@/assets/images/BjbfBuilders&Developers.jpeg';
import gillcoImg from '@/assets/images/Gilco.png';
import orchidGreensImg from '@/assets/images/OrchidGreens.png';
import risingGreensImg from '@/assets/images/RisingGreens.png';
import nobleWillasaImg from '@/assets/images/NobleWillasa.png';
import ubberParkland from '@/assets/images/UbberParkland.png';
import northAurellia from '@/assets/images/NorthAurellia.png';
import antaara from '@/assets/images/Antaara.jpg';
import bollywoodGreens from '@/assets/images/BollywoodGreen.png';
import ceedee from '@/assets/images/Ceedee.png';
import divinegroup from '@/assets/images/Divinegroup.png';
import exoticaHomez from '@/assets/images/Exoticahomez.png';
import gdplMohali from '@/assets/images/Gdplmohali.png';
import goldenAvenue from '@/assets/images/Goldenavenue.png';
import mongaCity from '@/assets/images/Mongacity.png';
import nobleCalista from '@/assets/images/NobleCalista.jpg';
import nobleMangolia from '@/assets/images/NobleMangolia.png';
import nobleVentures from '@/assets/images/NobleVentures.png';
import parkStreet from '@/assets/images/ParkStreet.png';
import prestigeTowers from '@/assets/images/PrestigeTowers.png';
import sbpGroup from '@/assets/images/SbpGroup.png';
import vrsMohali from '@/assets/images/VrsMohali.png';

const projects = ref([
  {
    name: 'Leela Orchid Greens',
    description: 'Modern living spaces designed for comfort and elegance.',
    image: orchidGreensImg,
  },
  {
    name: 'Absolute Residency',
    description: 'Premium residential project offering luxury amenities.',
    image: absoluteResidencyImg,
  },
  {
    name: 'Rising Greens',
    description: 'Eco-friendly community living by Pride Infra.',
    image: risingGreensImg,
  },
  {
    name: 'Gillco',
    description: 'Discover the new horizon in living with modern developments.',
    image: gillcoImg,
  },
  {
    name: 'Noble Willasa',
    description: 'Thoughtfully designed homes to live an enriched life.',
    image: nobleWillasaImg,
  },
  {
    name: 'BJBF Builders',
    description: 'Quality construction and reliable real estate solutions.',
    image: bjbfBuildersImg,
  },
  {
    name: 'Ubber Parkland',
    description:
      'Modern residential spaces designed for comfort and sustainable living.',
    image: ubberParkland,
  },
  {
    name: 'North Aurellia',
    description:
      'Elevating lifestyles with sophisticated aesthetics and world-class amenities.',
    image: northAurellia,
  },
  {
    name: 'Antaara',
    description:
      'Exquisite living environments crafted with meticulous attention to detail.',
    image: antaara,
  },
  {
    name: 'Bollywood Greens',
    description:
      'Merging lush greenery with contemporary luxury for a serene home experience.',
    image: bollywoodGreens,
  },
  {
    name: 'Cee Dee Green Woods',
    description:
      'Nature-inspired housing solutions focused on tranquility and wellness.',
    image: ceedee,
  },
  {
    name: 'Divine Group',
    description:
      'Setting benchmarks in excellence through high-end commercial and residential hubs.',
    image: divinegroup,
  },
  {
    name: 'Exotica Homez',
    description:
      'Redefining elegance with spacious layouts and state-of-the-art facilities.',
    image: exoticaHomez,
  },
  {
    name: 'GDPL Mohali',
    description:
      'Reliable engineering meets innovative design in the heart of Mohali.',
    image: gdplMohali,
  },
  {
    name: 'Golden Avenue',
    description:
      'Premier real estate developments offering an unmatched sense of community.',
    image: goldenAvenue,
  },
  {
    name: 'Monga City Center',
    description:
      'Dynamic commercial and mixed-use spaces designed for thriving businesses.',
    image: mongaCity,
  },
  {
    name: 'Noble Calista',
    description:
      'A sanctuary of luxury offering bespoke residences for the modern family.',
    image: nobleCalista,
  },
  {
    name: 'Noble Mangolia',
    description:
      'Exceptional craftsmanship and timeless design in every square foot.',
    image: nobleMangolia,
  },
  {
    name: 'Noble Ventures',
    description:
      'Transforming visions into reality with iconic landmark developments.',
    image: nobleVentures,
  },
  {
    name: 'Park Street',
    description:
      'Strategically located urban spaces tailored for convenience and style.',
    image: parkStreet,
  },
  {
    name: 'Prestige Towers',
    description:
      'High-rise living at its finest, offering breathtaking views and exclusivity.',
    image: prestigeTowers,
  },
  {
    name: 'SBP Group',
    description:
      'The region’s trusted name for quality homes and transparent dealings.',
    image: sbpGroup,
  },
  {
    name: 'VRS Mohali',
    description:
      'Commitment to durability and aesthetic excellence in residential planning.',
    image: vrsMohali,
  },
]);
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.grid-section {
  padding: 80px 0;
}

.community-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
}

.community-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  border: 1px solid #dbdada;
}

.community-card:hover {
  transform: translateY(-10px);
}

.card-image {
  position: relative;
  height: 240px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.community-card:hover .card-image img {
  transform: scale(0.5);
}

.card-overlay {
  position: absolute;
  inset: 0;
  background: rgba(185, 28, 28, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.community-card:hover .card-overlay {
  opacity: 1;
}

.view-btn {
  background: white;
  color: #b91c1c;
  border: none;
  padding: 12px 24px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}

.card-info {
  padding: 25px;
}

.card-info h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #111;
}

.card-info p {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.5;
}

.community-card:hover .card-image img {
  transform: scale(1.1);
}

@keyframes fadeInUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.animate-up {
  animation: fadeInUp 0.8s ease forwards;
  opacity: 0;
}

@media (max-width: 768px) {
  .community-grid {
    grid-template-columns: auto;
  }
}
</style>
